import EditUserRole from './EditUserRole';

export default EditUserRole;
